<ng-template #lazyLoadedComponent></ng-template>
